import { render } from "./Tabs.vue?vue&type=template&id=4ff1a0f8"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"
script.render = render

export default script